export default __webpack_public_path__ + "dist/media/File.4880f2b6.svg";